/* eslint-disable @typescript-eslint/no-explicit-any */

import type { AgodaHomes } from "../types";

type WindowWithAgodaHomes = Window & {
    agodahomes: AgodaHomes;
};

export const getAgoda = () => {
    if (!(window as unknown as WindowWithAgodaHomes).agodahomes) {
        (window as unknown as WindowWithAgodaHomes).agodahomes = {} as AgodaHomes;
    }

    return (window as unknown as WindowWithAgodaHomes).agodahomes;
};

const agodaHomes: AgodaHomes = getAgoda();
export { agodaHomes as agodahomes };
